module.exports = __webpack_public_path__ + "assets/img/HR-Connect-Website-w720.344382f3.jpg";